import CopyManage from './copy_manage.vue';

export default CopyManage;
